import { apiClient } from './client';

export async function getRecycleBin(params = {}) {
  const { data } = await apiClient.get('/api/system/data-lifecycle/recycle-bin', { params });
  return data;
}

export async function getDataLifecycleEvents(params = {}) {
  const { data } = await apiClient.get('/api/system/data-lifecycle/events', { params });
  return data;
}

export async function getDataPurgeJobs(params = {}) {
  const { data } = await apiClient.get('/api/system/data-lifecycle/purge-jobs', { params });
  return data;
}

export async function requestEntityDelete(entityType, id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/data-lifecycle/${entityType}/${id}/delete-request`, payload);
  return data.data;
}

export async function restoreEntity(entityType, id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/data-lifecycle/${entityType}/${id}/restore`, payload);
  return data.data;
}

export async function requestEntityPurge(entityType, id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/data-lifecycle/${entityType}/${id}/purge-request`, payload);
  return data.data;
}

export async function processPurgeJob(jobId) {
  const { data } = await apiClient.post(`/api/system/data-lifecycle/purge-jobs/${jobId}/process`);
  return data.data;
}

export async function applyLegalHold(entityType, id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/data-lifecycle/${entityType}/${id}/legal-hold`, payload);
  return data.data;
}

export async function releaseLegalHold(entityType, id, payload = {}) {
  const { data } = await apiClient.delete(`/api/system/data-lifecycle/${entityType}/${id}/legal-hold`, { data: payload });
  return data.data;
}

export async function getRetentionPolicies(params = {}) {
  const { data } = await apiClient.get('/api/system/data-lifecycle/retention-policies', { params });
  return data;
}

export async function createRetentionPolicy(payload) {
  const { data } = await apiClient.post('/api/system/data-lifecycle/retention-policies', payload);
  return data.data;
}

export async function updateRetentionPolicy(id, payload) {
  const { data } = await apiClient.put(`/api/system/data-lifecycle/retention-policies/${id}`, payload);
  return data;
}
